import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDitlindjeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 21.497,
	viewBox: "0 0 18 21.497",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_5745",
		"data-name": "Group 5745",
		transform: "translate(-483 -464.503)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_8278",
			"data-name": "Path 8278",
			d: "M12.68,5.88a1.982,1.982,0,0,0,1.3-1.64,1.952,1.952,0,0,0-.28-1.27L12.42.75a.506.506,0,0,0-.87,0L10.27,2.97A2.079,2.079,0,0,0,10,4,2,2,0,0,0,12.68,5.88Zm3.85,10.04-1-1-1.08,1.07a3.543,3.543,0,0,1-4.89,0L8.49,14.92,7.4,15.99A3.435,3.435,0,0,1,4.96,17,3.474,3.474,0,0,1,3,16.39V20a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V16.39a3.469,3.469,0,0,1-2.74.52A3.516,3.516,0,0,1,16.53,15.92ZM18,9H13V8a1,1,0,0,0-2,0V9H6a3,3,0,0,0-3,3v1.46A2.021,2.021,0,0,0,4.31,15.4a1.976,1.976,0,0,0,2.03-.46l2.14-2.13,2.13,2.13a1.968,1.968,0,0,0,2.77,0l2.14-2.13,2.13,2.13a1.956,1.956,0,0,0,1.65.55,2.043,2.043,0,0,0,1.69-2.06V12.01A2.983,2.983,0,0,0,18,9Z",
			transform: "translate(480 464)"
		})
	})
});
export { SvgDitlindjeIcon as ReactComponent };
